import { wcfConfig } from "../utils";
import * as basket from "../eaiws/basket";
const getArticleDataOptions = new basket.GetArticleDataOptions();
getArticleDataOptions.noProperties = false;
getArticleDataOptions.fetchCatalogIcon = false;
getArticleDataOptions.fetchCatalogImage = true;
getArticleDataOptions.separateCurrencies = true;
/** Note: The returned object is static, its not a new instance! */
export function getDefaultGetArticleDataOptions() {
    const tConfOptions = wcfConfig.articleConfigurationOptions;
    getArticleDataOptions.fetchPropValueImages = tConfOptions.fetchPropValueImages;
    getArticleDataOptions.highResPropValueIcons = true;
    return (getArticleDataOptions);
}
